import { Type } from "class-transformer";
import { EnaioObjectTypeId } from "./EnaioObjectTypeId";
import { OrdinaryObject } from "src/modules/utils/shared/ordinary-object.model";

export class EnaioObjectTypeStatistics {
    @Type(() => EnaioObjectTypeId)
    id: EnaioObjectTypeId;
    objectCount = 0;
    documentCount = 0;
    documentCountByMimeType: OrdinaryObject<number>;
    fileSize = 0;
    fileSizeByMimeType: OrdinaryObject<number>;
    pageCount = 0;
    pageCountByMimeType: OrdinaryObject<number>;
    objectCountForeign = 0;
    objectCountByForeign: OrdinaryObject<number>;
    documentCountForeign = 0;
    documentCountByForeign: OrdinaryObject<number>;
    fileSizeForeign = 0;
    fileSizeByForeign: OrdinaryObject<number>;
    pageCountForeign = 0;
    pageCountByForeign: OrdinaryObject<number>;
    deletedCount = 0;
}
